import type { CloudCostLine, CloudCostReport } from "@hasheeai/types";
import { t } from "../../i18n";
import { CostLineHelp } from "./CloudCostLineHelp";
import { costMoney as money } from "./cloud-cost-data";
import { costServiceLabel, costUnitLabel } from "./cloud-cost-labels";
export function CostTable({
  lines,
  report,
}: { lines: CloudCostLine[]; report: CloudCostReport }): React.JSX.Element {
  return (
    <div style={{ overflow: "auto", maxHeight: 560 }}>
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          textAlign: "left",
          fontSize: 13,
        }}
      >
        <thead>
          <tr>
            {["invoice_item", "quantity", "fee_short"].map((key) => (
              <th key={key} style={cellStyle}>
                {t(`cost.${key}`)}
              </th>
            ))}
          </tr>
        </thead>
        {(["neon", "cloudflare"] as const).map((provider) => {
          const rows = lines.filter((line) => line.provider === provider);
          return rows.length ? (
            <tbody key={provider}>
              <tr>
                <th colSpan={3} scope="rowgroup" style={cellStyle}>
                  {provider === "neon" ? "Neon" : "Cloudflare"}
                </th>
              </tr>
              {rows.map((line) => (
                <CostRow key={line.id} line={line} report={report} />
              ))}
            </tbody>
          ) : null;
        })}
        {!lines.length && (
          <tbody>
            <tr>
              <td colSpan={3} style={cellStyle}>
                {t("cost.empty")}
              </td>
            </tr>
          </tbody>
        )}
      </table>
    </div>
  );
}
function CostRow({
  line,
  report,
}: { line: CloudCostLine; report: CloudCostReport }): React.JSX.Element {
  return (
    <tr>
      <td style={cellStyle}>
        {costServiceLabel(line.service)}
        <CostLineHelp line={line} report={report} />
      </td>
      <td style={cellStyle}>
        {line.quantity?.toLocaleString(undefined, {
          maximumFractionDigits: 4,
        }) ?? "—"}{" "}
        {costUnitLabel(line.unit)}
      </td>
      <td style={{ ...cellStyle, textAlign: "right" }}>
        {line.amount === null
          ? "—"
          : line.currency.toUpperCase() === "USD"
            ? money(line.amount)
            : `${line.amount} ${line.currency}`}
      </td>
    </tr>
  );
}
const cellStyle: React.CSSProperties = {
  padding: "10px 8px",
  borderBottom: "1px solid var(--color-border)",
};
